import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { applyPromoBannerPlanIntent } from "app/pages/Customer/FixedPhone/Checkout/utils/fixed-phone-storage";

import { Button } from "app/components/ui/button";
import {
  Marquee,
  MarqueeContent,
  MarqueeItem,
  MarqueeFade,
} from "app/components/ui/marquee";

interface Props {
  isVisible: boolean;
  onClose: () => void;
  productId?: string;
}

export const PromoBanner = ({ isVisible, onClose, productId }: Props) => {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      id="promo-banner"
      className={`sticky top-0 z-[60] w-full bg-[#FFE1D259] text-[#1D1D1B] overflow-hidden transition-all duration-300 ease-in-out cursor-pointer ${
        isVisible && productId
          ? "h-8 sm:h-[2.125rem] lg:h-9 opacity-100"
          : "h-0 opacity-0"
      }`}
      onClick={() => {
        if (!productId) return;
        applyPromoBannerPlanIntent(productId);
        navigate(
          `/fixed-phone/phone-base?id=${productId}&reset_ts=${Date.now()}`
        );
      }}
    >
      {/* bg-[linear-gradient(90deg,_rgba(255,245,238,1)_0%,_rgba(255,225,210,0.35)_49.41%,_rgba(255,115,55,0.35)_100%)] */}
      {productId && (
        <div className="relative flex items-center justify-center h-full w-full max-w-[85rem] mx-auto">
          <Marquee className="flex items-center justify-center sm:hidden w-full h-full pr-10">
            <MarqueeFade
              side="left"
              className="sm:hidden w-12 from-[#FFF5EE]"
            />
            <MarqueeFade
              side="right"
              className="sm:hidden from-[#FFF5EE] right-9"
            />
            <MarqueeContent pauseOnHover speed={50} autoFill>
              <MarqueeItem>
                <span className="inline-block font-bold leading-none text-[0.825rem] sm:text-sm md:text-[0.925rem] lg:text-base whitespace-nowrap pl-5 sm:pl-6 md:pl-7 lg:pl-9 xl:pl-12">
                  🎁 𝓯𝓻𝓮𝓮 4G Phone Base With Annual Plan + Free Shipping ✈️
                </span>
              </MarqueeItem>
            </MarqueeContent>
          </Marquee>
          <span className="hidden sm:inline-flex justify-center items-center font-bold leading-none text-[0.825rem] sm:text-sm md:text-[0.925rem] lg:text-base text-center w-full px-5 sm:px-6 md:px-7 lg:px-9 xl:px-12">
            🎁 𝓯𝓻𝓮𝓮 4G Phone Base With Annual Plan + Free Shipping ✈️
          </span>
          <Button
            type="button"
            variant="ghost"
            className="absolute z-10 right-3 sm:right-4 lg:right-5 h-auto hover:bg-transparent rounded-full"
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            aria-label="Close banner"
          >
            <img
              src="/assets/close.svg"
              alt="close"
              className="size-5 sm:size-[1.375rem] lg:size-6"
              style={{
                filter: isHovered
                  ? "brightness(0) saturate(100%) invert(27%) sepia(95%) saturate(7492%) hue-rotate(353deg) brightness(91%) contrast(84%)"
                  : "none",
                transition: "filter 0.2s ease-in-out",
              }}
            />
          </Button>
        </div>
      )}
    </div>
  );
};
